/**
 * O logotipo do Google, como PECA da plataforma.
 *
 * POR QUE ELE E UMA PECA, e nao markup dentro da tela de login: qualquer produto que ofereca
 * entrada por Google desenha exatamente este simbolo. Deixa-lo solto no `TelaLogin` faria a
 * proxima superficie que precisar dele copia-lo, e a copia e o que a premissa de fonte unica
 * do ADR 0028 existe para impedir.
 *
 * POR QUE AS CORES SAO LITERAIS AQUI, e este e o unico lugar da plataforma onde isso vale:
 * elas nao sao decisao nossa. Sao a identidade de um terceiro, publicada por ele, e trocar
 * qualquer uma por um token da nossa marca produziria um simbolo que o Google nao reconhece
 * como o dele. A diretriz de marca do Google exige o logotipo nas cores oficiais.
 *
 * A regra de lint `complexity/no-literal-colors` esta desligada NESTA PASTA, e so nela, com
 * o motivo escrito no proprio `eslint.config.js`. Marca de terceiro entra aqui; qualquer
 * outra cor literal continua proibida em todo o resto da plataforma.
 *
 * O SVG e INLINE, e nao um arquivo carregado: assim ele herda o tamanho pelo `className`,
 * acompanha o texto do botao, e nao custa uma requisicao extra na PRIMEIRA tela do sistema,
 * que e onde a espera mais pesa.
 */

/** Recebe o `className` para o consumidor decidir o tamanho, como toda peca de icone. */
export interface LogoGoogleProps {
  readonly className?: string;
}

export function LogoGoogle({ className = 'h-4 w-4 shrink-0' }: LogoGoogleProps) {
  return (
    // `aria-hidden` porque o texto do botao ao lado ja diz o que ele faz. Anunciar "imagem"
    // no meio da frase so atrapalha quem ouve.
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
      <path
        fill="#4285F4"
        d="M23 12.3c0-.8-.1-1.6-.2-2.3H12v4.5h6.2a5.3 5.3 0 0 1-2.3 3.5v2.9h3.7c2.2-2 3.4-5 3.4-8.6Z"
      />
      <path
        fill="#34A853"
        d="M12 23.5c3.1 0 5.7-1 7.6-2.8l-3.7-2.9c-1 .7-2.3 1.1-3.9 1.1-3 0-5.5-2-6.4-4.7H1.8v3A11.5 11.5 0 0 0 12 23.5Z"
      />
      <path fill="#FBBC05" d="M5.6 14.2a6.9 6.9 0 0 1 0-4.4v-3H1.8a11.5 11.5 0 0 0 0 10.4l3.8-3Z" />
      <path
        fill="#EA4335"
        d="M12 5.4c1.7 0 3.2.6 4.4 1.7l3.3-3.3A11.5 11.5 0 0 0 1.8 6.8l3.8 3c.9-2.7 3.4-4.4 6.4-4.4Z"
      />
    </svg>
  );
}
